<template>
  <b-row class="internal-mobility-dashboard" v-if="dashboard">
    <b-col cols="12" class="px-4 pt-1">

      <b-row class="my-4 px-4">
        <b-col class="welcome-block bg-primary-a1 px-3">
          <!-- h1 v-if="isSuperAdmin" class="my-4">
            <strong>Welcome back, {{user.firstName}}.</strong>
          </h1 -->
          <h1 class="my-4">
            <strong>Hey there, {{user.firstName}}.</strong>
            <template v-if="$root.isReferralsFeatureEnabled && ((dashboard.referralConnections && dashboard.referralConnections.total) || ((dashboard.totalActiveJobs && dashboard.totalActiveJobs.total)))">You have</template>
            <template v-if="$root.isReferralsFeatureEnabled && dashboard.matchesCount">
              <router-link :to="{ name: 'JobIndex' }">{{ dashboard.matchesCount | plural('match') }}</router-link><template v-if="dashboard.totalActiveJobs && dashboard.totalActiveJobs.total && dashboard.referralConnections && dashboard.referralConnections.total">, </template><template v-else> and </template>
            </template>
            <template v-if="$root.isReferralsFeatureEnabled && dashboard.referralConnections && dashboard.referralConnections.total && $root.isReferralsFeatureEnabled">
              <router-link :to="{ name: 'ReferralRequests' }">{{ dashboard.referralConnections.total | plural('referral request') }}</router-link>
              <template v-if="dashboard.totalActiveJobs && dashboard.totalActiveJobs.total"> and </template>
            </template>
            <template v-if="$root.isReferralsFeatureEnabled && dashboard.totalActiveJobs && dashboard.totalActiveJobs.total">
              <router-link :to="{ name: 'JobIndex' }">{{ dashboard.totalActiveJobs.total | plural('current opening') }}</router-link>
              <template>to refer to your contacts.</template>
            </template>
            <template v-if="!$root.isReferralsFeatureEnabled && dashboard.totalActiveJobs.total">
              <template>We currently have </template>
              <router-link :to="{ name: 'InternalJobIndex' }">{{ dashboard.totalActiveJobs.total | plural('internal opening') }}.</router-link>
            </template>
          </h1>
        </b-col>
      </b-row>

      <!--b-row class="my-4 px-2">
        <b-col>
          <b-alert v-if="profileCompletion.length" show dismissible>
            <p><span class="pr-2">👋</span>We have noticed that you have not yet completed your profile. Here are some of our recommendations to help you get the most out of this platform.</p>
            <ul>
              <li v-for="recommendation in profileCompletion" :key="recommendation">
                <template v-if="recommendation === 'NO_JOB_TITLE'">Set your current job title to keep your profile up-to-date</template>
                <template v-else-if="recommendation === 'NO_CURRENT_SKILLS'">Set your current skills so we can match you to relevant opportunities</template>
                <template v-else-if="recommendation === 'NOT_ENOUGH_CURRENT_SKILLS'">Add at least 4 skills to your profile, so we can match you to relevant opportunities</template>
                <template v-else-if="recommendation === 'NO_DEVELOPMENT_SKILLS'">Add skills you want to develop, so we can match you to relevant projects and mentors</template>
                <template v-else-if="recommendation === 'NOT_ENOUGH_DEVELOPMENT_SKILLS'">Add at least 4 skills you want to develop to your profile, so we can match you to relevant projects and mentors</template>
                <template v-else-if="recommendation === 'NO_BUSINESS_AREA'">Select at least one area of business you are interested in, so we can show you opportunities tailored to your interests</template>
              </li>
            </ul>
            <p>To finish setting up your profile, <router-link :to="{ name: 'Onboarding', params: { stepName: 'skills' } }">visit your profile page</router-link>.</p>
          </b-alert>
        </b-col>
      </b-row -->

      <b-alert v-if="dashboard && dashboard.completion && dashboard.completion.outstandingLinkedInNetworkSync"
        class="bg-primary-a1 my-3 px-2 d-flex flex-row justify-content-between align-items-center" show>
          <strong>Finish uploading your LinkedIn connections to get matches for jobs!</strong>
          <b-btn :to="{ name: 'Onboarding', params: { stepName: 'registernetwork' }, query: { finish: 'uploading', provider: 'linkedin' } }"
            class="ml-3" variant="primary">Upload Archive</b-btn>
      </b-alert>

      <b-alert v-if="hasUploadedContacts === true" class="my-3 px-2" show variant="warning">
        <strong>Your contacts are processing.</strong> This may take up to 10 minutes to complete.
      </b-alert>

      <b-row class="px-2 mb-4">
        <b-col cols="12" md="8">
          <b-card v-if="dashboard && dashboard.dashboardBlocks" class="h-100">
            <b-row class="pb-3 border-bottom">
              <b-col class="block-title">Our Platform</b-col>
            </b-row>
            <b-row class="pt-3">
              <b-col v-for="block in dashboard.dashboardBlocks" :key="block.name" cols="12" md="6" class="mb-3 pb-2">
                <p class="mb-0"><b>{{ dashboardBlocks.find(({ name }) => name === block.name).displayName }}</b></p>
                <p class="mb-0"><span class="text-muted">{{ dashboardBlocks.find(({ name }) => name === block.name).description }}</span></p>
                <p class="mb-0">
                  <b-link @click="$scrollTo(`#step_${block.name}`)">
                    <b>{{ dashboardBlocks.find(({ name }) => name === block.name).linkText }}</b>
                  </b-link>
                </p>
              </b-col>
              <b-col cols="12" md="6" class="mb-3">
                <sync-connections-button v-if="!isRecruiter && company.sitePreferences.canSyncContacts && $root.isReferralsFeatureEnabled" class="my-3 d-none d-md-block"/>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="12" md="4">
          <div v-if="company && company.siteBranding && company.siteBranding.imDashboardHeaderImage">
            <b-img fluid :src="company.siteBranding.imDashboardHeaderImage.fileLocation" />
          </div>
        </b-col>
      </b-row>

      <template v-if="dashboard && dashboard.dashboardBlocks">
        <b-row
          v-for="block in dashboard.dashboardBlocks"
          :key="block.name"
          :id="`step_${block.name}`"
          class="mb-3"
        >
          <b-col cols="12">
            <h3 class="px-3">{{ dashboardBlocks.find(({ name }) => name === block.name).displayName }}</h3>
            <!--p class="px-3">
              {{ dashboardBlocks.find(({ name }) => name === block.name).description }}
              <b-link
                class="float-right"
                v-if="$root.isInterestBasedMatching && block.name === 'suggested-projects'"
                @click="$router.push({ name: 'ProjectsIndex', query: { order: company.sitePreferences.defaultInternalJobOrderBy === 'MOST_RELEVANT_INTEREST' ? 'MOST_RELEVANT' : 'MOST_RELEVANT_INTEREST' } })"
              >
                See suggestions based on {{ company.sitePreferences.defaultInternalJobOrderBy === 'MOST_RELEVANT_INTEREST' ? 'skills' : 'interests' }}
              </b-link>
              <b-link
                class="float-right"
                v-if="$root.isInterestBasedMatching && block.name === 'suggested-jobs'"
                @click="$router.push({ name: 'InternalJobIndex', query: { order: company.sitePreferences.defaultInternalJobOrderBy === 'MOST_RELEVANT_INTEREST' ? 'MOST_RELEVANT' : 'MOST_RELEVANT_INTEREST' } })"
              >
                See suggestions based on {{ company.sitePreferences.defaultInternalJobOrderBy === 'MOST_RELEVANT_INTEREST' ? 'skills' : 'interests' }}
              </b-link>
            </p -->
            <div v-if="block.name === 'suggested-jobs' && !dashboard.hasMatchedJobs" class="p-2">
              <b-alert show dismissible>It seems like you don't currently have any matched jobs to your profile. See all our openings below.</b-alert>
            </div>
            <introduce
              v-if="block.name === 'introduce' && dashboard"
              :dashboard="dashboard"
            />
            <content-shares
              v-if="block.name === 'content-sharing' && Array.isArray(dashboard.contentShares)"
              :contentShares="dashboard.contentShares.slice(0, 4)"
            />
            <suggested-jobs
              v-if="block.name === 'suggested-jobs' && Array.isArray(dashboard.jobs)"
              :jobs="dashboard.jobs.slice(0, 3)"
            />
            <suggested-project-jobs
              v-if="block.name === 'suggested-projects' && Array.isArray(dashboard.projectJobs)"
              :jobs="dashboard.projectJobs.slice(0, 3)"
            />
            <rewards-card v-if="block.name === 'reward-shop' && Array.isArray(dashboard.rewards)"
              class="my-3 d-none d-md-block"
              :rewards="dashboard.rewards" :claimed="dashboard.claimedRewards"
              :balance="dashboard.rewardTokensBalance" :total="dashboard.rewardTokensTotal" />
            <suggested-mentors
              v-if="block.name === 'mentorship' && Array.isArray(dashboard.mentors)"
              :mentors="dashboard.mentors" :company="company" :user="user" :count="3"
              @submitContactMentorRequest="submitContactMentorRequest($event)"
            />
          </b-col>
        </b-row>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import base64 from 'base-64';
import ms from 'ms';
import enumsMixin from '@src/mixins/enums';
import JobsFilter from '@/components/jobs/FilterContainer';
import SuggestedJobs from '@/components/dashboard/SuggestedJobs.vue';
import SuggestedProjectJobs from '@/components/dashboard/SuggestedProjectJobs.vue';
import SuggestedMentors from '@/components/dashboard/SuggestedMentors.vue';
import ContentShares from '@/components/dashboard/ContentShares.vue';
import Introduce from '@/components/dashboard/Introduce.vue';
import DashboardWelcome from '@/components/dashboard/welcome';
import Leaderboard from '@/components/dashboard/dashboard-leaderboard';
import JobReferralsContainer from '@/components/job-referrals/container';
import RewardsCard from '@/components/rewards/Dashboard';
// import ShareWithColleaguesModal from '@/modals/share-with-colleagues';
import { mapRoot } from '@src/mixins/root';
import { parseIfPossible, getUserFieldValue } from '@src/lib/imMatching';

import BupaDentalPracticeAreaLeaderboard from '@/components/success/bupadental-practiceAreaLeaderboard';

// import DashboardRecruiterQuery from '@/graphql/queries/DashboardRecruiter.gql';
import DashboardEmployeeQuery from '@/graphql/queries/DashboardEmployee.gql';
import SuccessFunctionQuery from '@/graphql/queries/SuccessFunction.gql';
import MentorRequestCreateMutation from '@/graphql/mutations/MentorRequestCreate.gql';

const sessionStorage = 'sessionStorage' in global && global.sessionStorage ? global.sessionStorage : null;

const dashboardBlocks = [
  {
    name: 'introduce',
    displayName: 'Referrals',
    description: 'See your latest referrals and leaderboards',
    linkText: 'Go to Referrals',
  },
  {
    name: 'content-sharing',
    displayName: 'Content Sharing',
    description: 'Earn rewards by sharing great, awesome content!',
    linkText: 'Go to Sharable Content',
  },
  {
    name: 'suggested-jobs',
    displayName: 'Open Jobs',
    description: 'Check out all the latest roles found specifically for you!',
    linkText: 'Go to Your Jobs',
  },
  {
    name: 'suggested-projects',
    displayName: 'Open project roles',
    description: 'Take a look at the latest projects that need you!',
    linkText: 'Go to Your Projects',
  },
  {
    name: 'reward-shop',
    displayName: 'Reward Shop',
    description: 'Earn points with with referring friends or sharing content!',
    linkText: 'Go to Reward Shop',
  },
  {
    name: 'mentorship',
    displayName: 'Available Mentors',
    description: 'Want to be mentored? Or interested in being a mentee?',
    linkText: 'Go to Mentors',
  },
];

const defaultJobSort = (a, b) => {
  if (!a.imMatchingDetails || !b.imMatchingDetails) return 0;
  const { skillScore: skillScoreA, interestScore: interestScoreA } = a.imMatchingDetails || {};
  const { skillScore: skillScoreB, interestScore: interestScoreB } = b.imMatchingDetails || {};
  const scoreA = interestScoreA + skillScoreA * 0.1;
  const scoreB = interestScoreB + skillScoreB * 0.1;
  return -1 * (scoreA - scoreB);
};

const defaultMentorSort = (a, b) => {
  if (!a.imMatchingDetails || !b.imMatchingDetails) return 0;
  return -1 * (a.imMatchingDetails.skillScore - b.imMatchingDetails.skillScore);
};

export default {
  name: 'InternalMobilityDashboard',
  components: {
    SuggestedJobs,
    JobsFilter,
    // OnboardingChecklist,
    DashboardWelcome,
    JobReferralsContainer,
    Leaderboard,
    // ShareWithColleaguesModal,
    BupaDentalPracticeAreaLeaderboard,
    SuggestedProjectJobs,
    ContentShares,
    Introduce,
    RewardsCard,
    SuggestedMentors,
  },
  mixins: [
    enumsMixin,
  ],
  data: () => ({
    referrals: null,
    filterJobsWhere: {
      // matches: { gt: 0 },
      status: 'ACTIVE',
    },
    filterJobsOrder: 'CREATED_DESC',
    // filterMatchesRelevance: 1.0,
    hasMoreJobsFilter: null,
  }),
  created() {
    // const { STRONG } = this.contactRelevanceBoundaries;
    // this.filterMatchesRelevance = STRONG;

    if (this.company && this.company.sitePreferences) {
      const { company: { sitePreferences } } = this;
      this.filterJobsOrder = (this.isRecruiter ? sitePreferences.defaultRecruiterJobOrderBy
        : sitePreferences.defaultJobOrderBy) || this.filterJobsOrder;
      if (this.$root && this.$root.isOnlyMentorship) {
        this.$router.replace({ name: 'MentorsIndex' });
      }
    }
  },
  apollo: {
    dashboard: {
      query: DashboardEmployeeQuery,
      variables() {
        const { sitePreferences: { defaultInternalJobOrderBy } = {} } = this.company;
        return {
          jobOrder: defaultInternalJobOrderBy || 'MOST_RELEVANT_INTEREST',
          projectOrder: defaultInternalJobOrderBy || 'MOST_RELEVANT_INTEREST',
        };
      },
      update({ company, user }) {
        const {
          jobAggs, sharePreferences, shareTemplates,
          totalActiveJobs, dashboardBranding, contentShares,
          rewards, mentors: mentorsRaw,
          jobs, projectJobs,
        } = company;
        const {
          matchesCount, leaderboards, referralConnections,
          jobConnections, rewardTokensBalance,
          claimedRewards, mentorRequests,
        } = user;
        let mentors = null;
        if (mentorsRaw) {
          console.log('MENTORS RAW: ', mentorsRaw);
          console.log('MENTOR REQUESTS: ', mentorRequests);
          console.log('PROJECT JOBS: ', projectJobs);
          console.log('JOBS: ', jobs);
          jobs.sort(defaultJobSort);
          projectJobs.sort(defaultJobSort);
          mentorsRaw.sort(defaultMentorSort);
          mentors = mentorsRaw.map(el => {
            const mentorRequest = mentorRequests.find(({ mentor: { id: mentorID } }) => mentorID === el.id);
            el.mentorRequest = {};
            if (mentorRequest) {
              el.mentorRequest = mentorRequest;
            }
            return el;
          }).filter(el => {
            const maxMentees = parseIfPossible(getUserFieldValue.call(this, el, 'RANGE', 'mentorship'));
            if (maxMentees && Number.isInteger(maxMentees) && maxMentees > 0 && Array.isArray(el.menteeRequests)) {
              return el.menteeRequests.length < maxMentees;
            }
            return true;
          });
        }
        const matchedJobs = (Array.isArray(this.filterJobs(jobs)) ? this.filterJobs(jobs) : []);
        const matchedProjectJobs = (Array.isArray(this.filterJobs(projectJobs)) ? this.filterJobs(projectJobs) : []);

        console.log('MATCHED JOBS: ', matchedJobs);
        console.log('MATCHED PROJECT JOBS: ', matchedProjectJobs);

        return {
          jobAggs,
          totalActiveJobs,
          sharePreferences,
          shareTemplates,
          matchesCount,
          dashboardCard: dashboardBranding ? dashboardBranding.dashboardCard : null,
          leaderboards,
          referralConnections,
          jobConnections,
          dashboardBlocks: dashboardBranding && Array.isArray(dashboardBranding.dashboard) ? dashboardBranding.dashboard.filter(({ name }) => {
            return this.$root.isReferralsFeatureEnabled || ![ 'reward-shop', 'introduce' ].includes(name);
          }) : null,
          hasMatchedJobs: matchedJobs.length > 0,
          jobs: [
            ...matchedJobs,
            ...jobs.slice(matchedJobs.length, 3),
          ],
          projectJobs: [
            ...matchedProjectJobs,
            ...projectJobs.slice(matchedProjectJobs.length, 3),
          ],
          contentShares: Array.isArray(contentShares) ? contentShares.filter(({ image, imageURL, description }) => (image || imageURL) && description) : null,
          rewards,
          rewardTokensBalance,
          claimedRewards,
          mentors
        };
      },
      error(err) {
        this.$notifyFatalErr(err, { prepend: 'Failed to load the dashboard' });
      },
      skip() {
        return !this.isLoggedIn;
      },
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    },
    success_getPracticeAreaLeaderboard: {
      query: SuccessFunctionQuery,
      variables: { name: 'bupadental-getPracticeAreaLeaderboard' },
      update({ company }) {
        const { successFunction } = company || {};
        return successFunction || {};
      },
      error(err) {
        this.$log.error(err);
      },
      skip() {
        return !(this.isLoggedIn && this.isBupaDental);
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
  },
  metaInfo() {
    return {
      title: this.$t('navigation.dashboard'),
    };
  },
  computed: {
    ...mapRoot([
      'company', 'user',
      'isLoggedIn', 'isRecruiter', 'isSuperAdmin',
      'isBupaDental', 'isSainsburys',
    ]),
    leaderboards() {
      if (this.company && this.company.sitePreferences && this.company.sitePreferences.useGamification) {
        const filterActiveDates = ({ startDate, endDate }) => (!startDate || startDate < Date.now()) && (!endDate || endDate > Date.now());
        if (this.isRecruiter) {
          return (Array.isArray(this.dashboard.leaderboards) ? this.dashboard.leaderboards : []).filter(filterActiveDates);
        } else {
          let leaderboards = (Array.isArray(this.dashboard.leaderboards) ? this.dashboard.leaderboards : []).filter(filterActiveDates);
          if (this.company.handle === 'mckesson') {
            leaderboards = leaderboards.filter(({ type }) => type === 'INDIVIDUALS');
          }
          return leaderboards;
        }
      }
      return null;
    },
    hasUploadedContacts() {
      if (sessionStorage.getItem('lastUploadedAt')) {
        const lastUploadedAt = new Date(sessionStorage.getItem('lastUploadedAt'));
        if (Number.isNaN(lastUploadedAt.getTime())) {
          this.$log.debug('Clearing lastUploadedAt since isNaN');
          sessionStorage.removeItem('lastUploadedAt');
          return null;
        }

        if ((lastUploadedAt.getTime() + ms('10m')) < Date.now()) {
          this.$log.debug('Clearing lastUploadedAt since older than 10m');
          sessionStorage.removeItem('lastUploadedAt');
          return null;
        }

        this.$log.debug('Contacts lastUploadedAt within last 10m');
        return true;
      }

      return null;
    },
    dashboardBlocks() {
      return dashboardBlocks.map(item => {
        const { company } = this;
        if (item.name === 'suggested-jobs') {
          item.description = company.sitePreferences.defaultInternalJobOrderBy === 'MOST_RELEVANT_INTEREST' ? 'Most relevant jobs based on your interests' : 'Most relevant jobs based on your interests';
        }
        if (item.name === 'suggested-projects') {
          item.description = company.sitePreferences.defaultInternalJobOrderBy === 'MOST_RELEVANT_INTEREST' ? 'Most relevant project roles based on your interests' : 'Most relevant project roles based on your interests';
        }
        return item;
      });
    },
    isRewardsEnabled() {
      const { isRewardsEnabled } = (this.company || {}).sitePreferences || {};
      const { rewards } = this.dashboard || {};
      return isRewardsEnabled === true && Array.isArray(rewards) && rewards.length;
    },
    profileCompletion() {
      const { company: { customFields: companyCustomFields } = {}, user: { customFields: userCustomFields = [] } = {} } = this;
      const recommendations = [];
      if (Array.isArray(companyCustomFields) && Array.isArray(userCustomFields)) {
        companyCustomFields.forEach(({ key, type, group }) => {
          const userField = userCustomFields.find(el => el.key === key);
          const value = parseIfPossible(userField ? userField.value : null);
          const isValueNull = !value;
          const isValueEmpty = !Array.isArray(value) || value.length === 0;
          const isValueNotSufficient = len => Array.isArray(value) && value.length < len;
          if (group === 'skills' && type === 'JOB_TITLES' && isValueNull) {
            recommendations.push('NO_JOB_TITLE');
          } else if (group === 'skills' && type === 'JOB_SKILLS') {
            console.log('VALUE: ', value);
            if (isValueEmpty) {
              recommendations.push('NO_CURRENT_SKILLS');
            } else if (isValueNotSufficient(4)) {
              recommendations.push('NOT_ENOUGH_CURRENT_SKILLS');
            }
          } else if (group === 'skills' && type === 'JOB_DEVELOPMENT_SKILLS') {
            if (isValueEmpty) {
              recommendations.push('NO_DEVELOPMENT_SKILLS');
            } else if (isValueNotSufficient(4)) {
              recommendations.push('NOT_ENOUGH_DEVELOPMENT_SKILLS');
            }
          } else if (group === 'interest' && type === 'JOB_BUSINESS_AREA' && isValueEmpty) {
            recommendations.push('NO_BUSINESS_AREA');
          }
        });
      }
      // console.log({ companyCustomFields, userCustomFields });
      return recommendations;
    },
  },
  methods: {
    filterJobsWhereUpdated(where) {
      this.filterJobsWhere = where;

      this.hasMoreJobsFilter = base64.encode(JSON.stringify({
        where: this.filterJobsWhere,
        order: this.filterJobsOrder,
      }));
      this.$scrollTo('.jobs-filter-container');
    },
    filterJobsOrderUpdated(order) {
      this.filterJobsOrder = order;

      this.hasMoreJobsFilter = base64.encode(JSON.stringify({
        where: this.filterJobsWhere,
        order: this.filterJobsOrder,
      }));
      this.$scrollTo('.jobs-filter-container');
    },
    finishedReferralRequest({ referralID }) {
      try {
        const client = this.$apollo.getClient();

        // Fetch query & variables from the Apollo definition above, D-R-Y!
        const query = this.$options.apollo.dashboard.query.call(this);
        const data = client.readQuery({ query });

        if (data && data.user && data.user.referralConnections) {
          data.user.referralConnections.edges = data.user.referralConnections.edges.filter(({ entry: { id } }) => id !== referralID);
          data.user.referralConnections.total--;
        }

        client.writeQuery({ query, data });
      } catch (err) {
        this.$log.error(err);
      }
    },
    async submitContactMentorRequest(form) {
      const { mentor, form: { message, selectedSkills: skills } } = form;
      const create = {
        message,
        skills,
        mentor: {
          id: mentor.id,
        },
      };
      try {
        const { data } = await this.$apollo.mutate({
          mutation: MentorRequestCreateMutation,
          variables: { create },
          update: (store, { data: { createMentorRequest } }) => {
            const { sitePreferences: { defaultInternalJobOrderBy } = {} } = this.company;
            const data = store.readQuery({
              query: DashboardEmployeeQuery,
              variables: {
                jobOrder: defaultInternalJobOrderBy || 'MOST_RELEVANT_INTEREST',
                projectOrder: defaultInternalJobOrderBy || 'MOST_RELEVANT_INTEREST',
              },
            });
            if (data && data.user && Array.isArray(data.user.mentorRequests)) {
              data.user.mentorRequests.push(createMentorRequest);
            }
            store.writeQuery({ query: DashboardEmployeeQuery, data });
          },
        });
        console.log('SUCCESS: ', data);
        Promise.resolve(this.$root.captureLog({
          eventName: 'IM_NEW_MENTOR_REQUEST',
          user: { id: this.user.id },
          data: [ { key: 'mentorID', value: mentor.id } ],
        }));
      } catch (error) {
        console.error(error);
      }
    },
    filterJobs(jobs) {
      const filteredJobs = (Array.isArray(jobs) ? jobs : []).filter(job => {
        const { imMatchingDetails } = job;
        if (!imMatchingDetails) return false;
        const { skillScore, interestScore } = imMatchingDetails;
        const score = interestScore + skillScore * 0.1;
        return score >= 2;
      });
      return filteredJobs;
    },
  },
};
</script>

<style lang="scss">
.internal-mobility-dashboard {
  h1 {
    font-size: 24px;
    font-weight: bold;
  }
  .block-title {
    text-transform: uppercase;
  }
  .upload-button {
    text-align: center;
    border-radius: 4px;
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
    h3 {
      display: inline-block;
    }
    p {
      margin-block-start: 0;
      margin-block-end: 0;

    }
    &.card {
      padding: 0.5em;
      .card-body {
        padding: 0.5em;
      }
    }
  }

  .welcome-block {
    h1 {
      line-height: 1.28;
      font-weight: 400;
    }
    &.row {
      margin-left: 0px;
      margin-right: 0px
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboards/InternalMobility.vue